import { render, staticRenderFns } from "./BankRemitData.vue?vue&type=template&id=bcc2df9a&scoped=true"
import script from "./BankRemitData.vue?vue&type=script&lang=js"
export * from "./BankRemitData.vue?vue&type=script&lang=js"
import style0 from "./BankRemitData.vue?vue&type=style&index=0&id=bcc2df9a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc2df9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-sea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcc2df9a')) {
      api.createRecord('bcc2df9a', component.options)
    } else {
      api.reload('bcc2df9a', component.options)
    }
    module.hot.accept("./BankRemitData.vue?vue&type=template&id=bcc2df9a&scoped=true", function () {
      api.rerender('bcc2df9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BankRemitData.vue"
export default component.exports